import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';

const ProfileLockButtons = ({
    focusKey,
    bgColor = "#1da1f2",
    text = "Done",
    onClick = () => { },
}) => {
    const { ref, focused } = useFocusable({
        focusKey: focusKey,
        isFocusBoundary: true,
        onEnterRelease: () => { onClick() },
    });
    return (
        <FocusContext.Provider value={focusKey} >
            <div ref={ref} style={{ borderRadius: "30px", width: "300px", height: "50px", backgroundColor: bgColor, color: "white", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold", letterSpacing: "1px", cursor: "pointer", outline: focused ? "2px solid white" : "2px solid transparent", marginBottom: "20px" }} onClick={onClick}>{text}</div>
        </FocusContext.Provider>
    );
}
export default ProfileLockButtons;
